import { JavaProgramsWrapper } from './JavaPrograms.styled';
import AccordionPagination from '../utils/Pagination/AccordionPagination';
import CommentSection from '../utils/CommentSection/CommentSection';

function JavaPrograms() {

   const data = [
      { 
         header: '1. Program to find whether a given number is even or odd.', 
         body: 
         'public class P1_EvenNumber {\n'+
         '  public static void main(String[] args) {\n'+
         '    int num = 51;\n'+
         '\n'+
         '    // using mod(%) which gives us the remainder\n'+
         '    // comparing remainder with zero\n'+
         '    if (num % 2 == 0) {\n'+
         '      System.out.println(num + " : Number is Even");\n'+
         '    } else {\n'+
         '      System.out.println(num + " : Number is Odd");\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '2. Program to find whether a given number is prime or not.', 
         body:  
         ' public class P2_PrimeNumber {\n'+
         '\n'+
         '   public static void main(String[] args) {\n'+
         '\n'+
         '     int num = 23;\n'+
         '     int flag = 0;\n'+
         '\n'+
         '     if (num == 1) {\n'+
         '       System.out.println(" 1 is neither prime nor composite");\n'+
         '     } else {\n'+
         '       // check for number less than half of it as it will not be completely divisible by\n'+
         '       // number more than it\n'+
         '       // starting with 2 as 1 is neither prime nor composite\n'+
         '       for (int i = 2; i <= (num / 2); i++) {\n'+
         '\n'+
         '         // check divisible by i or not\n'+
         '         // if divisible, then not prime\n'+
         '         if (num % i == 0) {\n'+
         '           flag++;\n'+
         '         }\n'+
         '       }\n'+
         '\n'+
         '       if (flag>0) {\n'+
         '         System.out.println(num + " is not a Prime Number");\n'+
         '       } else {\n'+
         '         System.out.println(num + " is a Prime Number");\n'+
         '       }\n'+
         '     }\n'+
         '   }\n'+
         ' }'
      },
      { 
         header: '3. Program to print the first 10 numbers of the Fibonacci Series.', 
         body:  
         'public class P3_FibonacciSeries {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    int i = 0;\n'+
         '    int j = 1;\n'+
         '    int z = 0;\n'+
         '\n'+
         '    //Print first 10 numbers of fibonacci series\n'+
         '    int count = 10;\n'+
         '    \n'+
         '    System.out.println(i);\n'+
         '    System.out.println(j);\n'+
         '\n'+
         '    //Adding up values and resetting values of i and j with the latest values(previous)\n'+
         '    for (int k = 0; k<count - 2; k++) {\n'+
         '      z = i + j;\n'+
         '      i = j;\n'+
         '      j = z;\n'+
         '      System.out.println(z);\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '4. Program to check whether a number is Armstrong number or not.', 
         body:  
         'public class P4_ArmstrongNumber {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    int inputNum = 370;\n'+
         '    int sumOfCube = 0;\n'+
         '    int num = inputNum;\n'+
         '\n'+
         '    while (num>0) {\n'+
         '\n'+
         '      //calculate sumOfCube\n'+
         '\n'+
         '      //fetch last digit of number by using mod(%)\n'+
         '      int lastDigit = num % 10;\n'+
         '\n'+
         '      //updating num by removing the last digit\n'+
         '      num = num / 10;\n'+
         '\n'+
         '      //Add sum of cubes of each digit\n'+
         '      sumOfCube = sumOfCube + (lastDigit * lastDigit * lastDigit);\n'+
         '    }\n'+
         '    if (sumOfCube == inputNum) {\n'+
         '      System.out.println(inputNum + " is an ArmstrongNumber");\n'+
         '    } else {\n'+
         '      System.out.println(inputNum + " is not an Armstrong Number");\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '5. Program to find the factorial of a number.', 
         body:  
         ' public class P5_Factorial {\n'+
         '\n'+
         '   public static void main(String[] args) {\n'+
         '\n'+
         '     int num = 5;\n'+
         '     int factorial = 1;\n'+
         '\n'+
         '     //multiply in decreasing order by decrementing till you reach 1\n'+
         '     // we will apply a reverse loop\n'+
         '     for (int i = num; i>0; i--) {\n'+
         '       factorial = factorial * i;\n'+
         '     }\n'+
         '     System.out.println("Factorial of " + num + " is : " + factorial);\n'+
         '   }\n'+
         ' }'
      },
      { 
         header: '6. Program to find the factorial of a number using recursion.', 
         body:  
         'public class P6_FactorialUsingRecursion {\n'+
         '\n'+
         '  //Number to check factorial for\n'+
         '  int num = 5;\n'+
         '\n'+
         '  //Number to store factorial\n'+
         '  int result = 1;\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    FactorialUsingRecursion f = new FactorialUsingRecursion();\n'+
         '    System.out.println(f.fact(f.num));\n'+
         '  }\n'+
         '\n'+
         '  public int fact(int num) {\n'+
         '    if (num>0) {\n'+
         '      result = result * num;\n'+
         '\n'+
         '      //calling recursively\n'+
         '      fact(num - 1);\n'+
         '    }\n'+
         '    return result;\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '7. Program to find missing numbers in an array between 1 to 10.', 
         body:  
         'import java.util.Arrays;\n'+
         '\n'+
         'public class P7_MissingNumbersInArray {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    int[] input = { 5, 7, 6, 2 };\n'+
         '    int index = 0;\n'+
         '    Arrays.sort(input);\n'+
         '\n'+
         '    //Approach 1\n'+
         '    System.out.println("Approach 1");\n'+
         '    System.out.println("----------");\n'+
         '    int limit = input[input.length - 1];\n'+
         '\n'+
         '    for (int i = 1; i<limit; i++) {\n'+
         '      if (input[index] == i) {\n'+
         '        index++;\n'+
         '      } else {\n'+
         '        System.out.println(i);\n'+
         '      }\n'+
         '    }\n'+
         '    while (limit<10) {\n'+
         '      System.out.println(++limit);\n'+
         '    }\n'+
         '\n'+
         '    //Approach 2\n'+
         '    System.out.println("Approach 2");\n'+
         '    System.out.println("----------");\n'+
         '\n'+
         '    int[] output = new int[11];\n'+
         '\n'+
         '    for (int i: input) {\n'+
         '      output[i] = 1;\n'+
         '    }\n'+
         '    for (int i = 1; i<output.length; i++) {\n'+
         '      if (output[i] == 0) System.out.println(i);\n'+
         '    }\n'+
         '\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '8. Program to find the reverse of a string.', 
         body:  
         'public class P8_ReverseAString {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    String originalString = "Miss TecHack";\n'+
         '    String reversedString = "";\n'+
         '\n'+
         '    //convert string to char array\n'+
         '    char[] charArray = originalString.toCharArray();\n'+
         '\n'+
         '    //Applying a reverse loop\n'+
         '    for (int i = charArray.length - 1; i>= 0; i--) {\n'+
         '\n'+
         '      //appending string in reverse order\n'+
         '      reversedString = reversedString + charArray[i];\n'+
         '    }\n'+
         '\n'+
         '    System.out.println("Original String : " + originalString);\n'+
         '    System.out.println("Reversed String : " + reversedString);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '9. Program to find the reverse of a string using recursion.', 
         body:  
         'public class P9_ReverseAStringUsingRecursion {\n'+
         '\n'+
         '  String input = "Recursion";\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    ReverseAStringUsingRecursion r = new ReverseAStringUsingRecursion();\n'+
         '    System.out.println(r.reverse(r.input));\n'+
         '  }\n'+
         '\n'+
         '  public String reverse(String inputString) {\n'+
         '    if (inputString.isEmpty()) {\n'+
         '      return inputString;\n'+
         '    }\n'+
         '    if (inputString.length()>0) {\n'+
         '      return inputString.charAt(inputString.length() - 1) + reverse(inputString.substring(0, inputString.length() - 1));\n'+
         '    }\n'+
         '    return null;\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '10. Program to find the reverse of a string using the default method.', 
         body:  
         'public class P10_ReverseAStringUsingDefaultMethod {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    StringBuffer input = new StringBuffer("Buffer");\n'+
         '    System.out.println(input.reverse());\n'+
         '\n'+
         '    StringBuilder input2 = new StringBuilder("Builder");\n'+
         '    System.out.println(input2.reverse());\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '11. Program to check whether a string is a palindrome or not.', 
         body:  
         'public class P11_Palindrome {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    String input = "level";\n'+
         '    String reverse = "";\n'+
         '    int flag = 0;\n'+
         '\n'+
         '    // Approach 1\n'+
         '    for (int j = input.length() - 1; j>= 0; j--) {\n'+
         '      reverse = reverse + input.charAt(j);\n'+
         '    }\n'+
         '    if (input.equals(reverse)) {\n'+
         '      System.out.println("String : " + input + " is a palindrome");\n'+
         '    } else {\n'+
         '      System.out.println("String : " + input + " is not a palindrome");\n'+
         '    }\n'+
         '\n'+
         '    // Approach 2\n'+
         '    for (int i = 0; i<input.length(); i++) {\n'+
         '      if (input.charAt(i) != input.charAt(input.length() - 1 - i)) {\n'+
         '        flag++;\n'+
         '      }\n'+
         '    }\n'+
         '    if (flag == 0) {\n'+
         '      System.out.println("String : " + input + " is a palindrome");\n'+
         '    } else {\n'+
         '      System.out.println("String : " + input + " is not a palindrome");\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '12. Program to check whether an integer is a palindrome or not.', 
         body:  
         'public class P12_IntegerPalindrome {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    int input = 4552554;\n'+
         '    int num = input;\n'+
         '    int reversedNum = 0;\n'+
         '    int lastDigit = 0;\n'+
         '\n'+
         '    while (num>0) {\n'+
         '      lastDigit = num % 10;\n'+
         '      num = num / 10;\n'+
         '      reversedNum = reversedNum * 10 + lastDigit;\n'+
         '    }\n'+
         '\n'+
         '    if (input == reversedNum) {\n'+
         '      System.out.println("Number : " + input + " is a palindrome");\n'+
         '    } else {\n'+
         '      System.out.println("Number : " + input + " is not a palindrome");\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '13. Program to check whether two strings are string anagram or not.', 
         body:  
         'import java.util.Arrays;\n'+
         '\n'+
         'public class P13_StringAnagram {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    String sInput1 = "Triangle";\n'+
         '    String sInput2 = "Integral";\n'+
         '\n'+
         '    //check for string length\n'+
         '    if (sInput1.length() != sInput2.length()) {\n'+
         '      System.out.println(sInput1 + " and " + sInput2 + " are not anagrams");\n'+
         '    } else {\n'+
         '\n'+
         '      //converting string to lowercase for comparision as anagrams are not case sensitive\n'+
         '      //converting it later to char array\n'+
         '      char[] sArray1 = sInput1.toLowerCase().toCharArray();\n'+
         '      char[] sArray2 = sInput2.toLowerCase().toCharArray();\n'+
         '\n'+
         '      //sort the arrays so its arranged from a-z sequentially\n'+
         '      Arrays.sort(sArray1);\n'+
         '      Arrays.sort(sArray2);\n'+
         '\n'+
         '      //equals will check for length of two array\n'+
         '      //It will also check if arrays are equal i.e, each character is same or not\n'+
         '      if (Arrays.equals(sArray1, sArray2)) {\n'+
         '        System.out.println(sInput1 + " and " + sInput2 + " are anagrams");\n'+
         '      } else {\n'+
         '        System.out.println(sInput1 + " and " + sInput2 + " are not anagrams");\n'+
         '      }\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '14. Program to show how a string is immutable in nature.', 
         body:  
         'public class P14_StringIsImmutable {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    // New object is created with string "Two" as assignment is done\n'+
         '    // input1 is assigned the address of new object that it is pointing to correctly\n'+
         '    // existing object does not change\n'+
         '    String input1 = "One";\n'+
         '    input1 = "Two";\n'+
         '    System.out.print("Output 1 : ");\n'+
         '    System.out.println(input1);\n'+
         '\n'+
         '    // New object is created with string "An Apple a day, keeps doctor away!"\n'+
         '    // Since assignment is not done, it is still pointing to the old object\n'+
         '    // existing object does not change\n'+
         '    String input2 = "An Apple";\n'+
         '    input2.concat(" a day, keeps doctor away!");\n'+
         '    System.out.print("Output 2 : ");\n'+
         '    System.out.println(input2);\n'+
         '\n'+
         '    // New object is not created, it picks up existing object with string "An Apple a day, keeps doctor away!" \n'+
         '    // input1 is assigned the address of new object that it is pointing to correctly\n'+
         '    // existing object does not change\n'+
         '    String input3 = "An Apple";\n'+
         '    input3 = input3.concat(" a day, keeps doctor away!");\n'+
         '    System.out.print("Output 3 : ");\n'+
         '    System.out.println(input3);\n'+
         '\n'+
         '    // New object is created with string "Winter is here!" as\n'+
         '    // assignment is done\n'+
         '    // input1 is assigned the address of new object that it is pointing to correctly\n'+
         '    // existing object does not change\n'+
         '    String input4 = "Winter";\n'+
         '    input4 = input4 + " is here!";\n'+
         '    System.out.print("Output 4 : ");\n'+
         '    System.out.println(input4);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '15. Program to find duplicate characters in a string.', 
         body:  
         'public class P15_DuplicateInAString {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    String inputString = "Love your self";\n'+
         '\n'+
         '    char[] inputArray = inputString.toCharArray();\n'+
         '    char[] outputArray = new char[inputString.length()];\n'+
         '\n'+
         '    int flag = 0;\n'+
         '    int index = 0;\n'+
         '\n'+
         '    outer: for (char c_outer: inputArray) {\n'+
         '\n'+
         '      //To check for every character of outer array\n'+
         '      flag = 0;\n'+
         '\n'+
         '      for (char c_inner: inputArray) {\n'+
         '\n'+
         '        //check if it matches a character and its not space\n'+
         '        //set flag to indicate duplicate exists\n'+
         '        if (c_outer == c_inner && c_outer != \' \') {\n'+
         '          flag++;\n'+
         '        }\n'+
         '      }\n'+
         '      if (flag>1) {\n'+
         '        //duplicate exists\n'+
         '\n'+
         '        //check if value is already present in output array\n'+
         '        for (int i = 0; i<outputArray.length; i++) {\n'+
         '\n'+
         '          if (c_outer == outputArray[i]) {\n'+
         '            continue outer;\n'+
         '          }\n'+
         '        }\n'+
         '        //set duplicate entry in output array\n'+
         '        outputArray[index] = c_outer;\n'+
         '        index++;\n'+
         '\n'+
         '      }\n'+
         '    }\n'+
         '    System.out.println("Duplicates in String \'" + inputString + "\' are - ");\n'+
         '    for (int i = 0; i<outputArray.length; i++) {\n'+
         '\n'+
         '      //As length of output array is equal to input array, so remaining values will be zero\n'+
         '      if (outputArray[i] != 0) {\n'+
         '        System.out.println(outputArray[i]);\n'+
         '      }\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '16. Program to find duplicate characters in a string using a HashMap.', 
         body:  
         'import java.util.HashMap;\n'+
         'import java.util.Map;\n'+
         '\n'+
         'public class P16_DuplicateInAStringUsingMap {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    String input = "Programming";\n'+
         '    Map<Character, Integer> output = new HashMap<Character, Integer>();\n'+
         '\n'+
         '    char[] characters = input.toCharArray();\n'+
         '\n'+
         '    for (char c: characters) {\n'+
         '      if (output.containsKey(c)) {\n'+
         '        output.put(c, output.get(c) + 1);\n'+
         '      } else {\n'+
         '        output.put(c, 1);\n'+
         '      }\n'+
         '    }\n'+
         '    for (char c_o: output.keySet()) {\n'+
         '      if (output.get(c_o)>1) {\n'+
         '        System.out.println("Character: " + c_o + " Count: " + output.get(c_o));\n'+
         '      }\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '17. Program to remove duplicates from an ArrayList.', 
         body:  
         'import java.util.ArrayList;\n'+
         'import java.util.LinkedHashSet;\n'+
         '\n'+
         'public class P17_RemoveDuplicateFromArrayList {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    ArrayList<String>list = new ArrayList<String>();\n'+
         '    list.add("Two");\n'+
         '    list.add("One");\n'+
         '    list.add("Three");\n'+
         '    list.add("Four");\n'+
         '    list.add("Three");\n'+
         '    list.add("Two");\n'+
         '    list.add("Five");\n'+
         '    list.add("Two");\n'+
         '\n'+
         '    LinkedHashSet<String> newList = new LinkedHashSet<String>(list);\n'+
         '    list.clear();\n'+
         '    list.addAll(newList);\n'+
         '\n'+
         '    System.out.println(list);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '18. Program to print a triangle of stars.', 
         body:  
         'public class P18_PrintTriangleOfStars {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    int n = 5;\n'+
         '    for (int i = 0; i<n; i++) {\n'+
         '      for (int j = 0; j<i + 1; j++) {\n'+
         '        System.out.print("*");\n'+
         '      }\n'+
         '      System.out.println("");\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '19. Program to print a pyramid of stars.', 
         body:  
         'public class P19_PrintPyramidOfStars {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    int lines = 5;\n'+
         '    int spaces = lines - 1;\n'+
         '    int stars = 1;\n'+
         '\n'+
         '    for (int i = 0; i<lines; i++) {\n'+
         '\n'+
         '      stars = (i * 2) + 1;\n'+
         '      //print spaces\n'+
         '      for (int k = spaces; k>0; k--) {\n'+
         '        System.out.print(" ");\n'+
         '      }\n'+
         '\n'+
         '      //print stars\n'+
         '      for (int j = 0; j<stars; j++) {\n'+
         '        System.out.print("*");\n'+
         '      }\n'+
         '\n'+
         '      System.out.println("");\n'+
         '      spaces--;\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '20. Program to find the square root of a number.', 
         body:  
         'public class P20_SquareRootOfNumber {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    SquareRootOfNumber sqrt = new SquareRootOfNumber();\n'+
         '    int num = 16;\n'+
         '\n'+
         '    //default method\n'+
         '    System.out.println(Math.sqrt(num));\n'+
         '\n'+
         '    //custom approach \n'+
         '    //prints only if perfect sqrt present\n'+
         '    for (int i = 1; i<num / 2; i++) {\n'+
         '      if (num / i == i && num % i == 0) {\n'+
         '        System.out.println(i);\n'+
         '        break;\n'+
         '      }\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '21. Program to find vowels and consonants in a String and count them.', 
         body:  
         'public class P21_VowelsAndConsonantsInString {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    String inputString = "Miss TecHack";\n'+
         '\n'+
         '    char[] vowels = new char[5];\n'+
         '    char[] consonants = new char[inputString.length()];\n'+
         '\n'+
         '    int v_flag = 0;\n'+
         '    int c_flag = 0;\n'+
         '\n'+
         '    int v_count = 0;\n'+
         '    int c_count = 0;\n'+
         '\n'+
         '    int index = 0;\n'+
         '\n'+
         '    System.out.println("For input string \'" + inputString + "\' -");\n'+
         '\n'+
         '    while (index<inputString.length()) {\n'+
         '\n'+
         '      //check vowels\n'+
         '      if (inputString.charAt(index) == \'a\' || inputString.charAt(index) == \'A\' ||\n'+
         '        inputString.charAt(index) == \'e\' || inputString.charAt(index) == \'E\' ||\n'+
         '        inputString.charAt(index) == \'i\' || inputString.charAt(index) == \'I\' ||\n'+
         '        inputString.charAt(index) == \'o\' || inputString.charAt(index) == \'O\' ||\n'+
         '        inputString.charAt(index) == \'u\' || inputString.charAt(index) == \'U\'\n'+
         '      ) {\n'+
         '        //set flag to zero to check for every index\n'+
         '        v_flag = 0;\n'+
         '\n'+
         '        //check if vowel is already present in vowels array and set flag\n'+
         '        for (int i = 0; i<vowels.length; i++) {\n'+
         '          if (inputString.charAt(index) == vowels[i]) {\n'+
         '            v_flag++;\n'+
         '          }\n'+
         '        }\n'+
         '        //if not present in array, add it\n'+
         '        //increment count\n'+
         '        if (v_flag == 0) {\n'+
         '          vowels[v_count] = inputString.charAt(index);\n'+
         '          v_count++;\n'+
         '        }\n'+
         '      }\n'+
         '      //check consonants\n'+
         '      else if ((inputString.charAt(index)>= \'a\' && inputString.charAt(index)<= \'z\') ||\n'+
         '        (inputString.charAt(index)>= \'A\' && inputString.charAt(index)<= \'Z\')\n'+
         '      ) {\n'+
         '        //set flag to zero to check for every index\n'+
         '        c_flag = 0;\n'+
         '\n'+
         '        //check if consonant is already present in consonants array and set flag\n'+
         '        for (int i = 0; i<consonants.length; i++) {\n'+
         '          if (inputString.charAt(index) == consonants[i]) {\n'+
         '            c_flag++;\n'+
         '          }\n'+
         '        }\n'+
         '        //if not present in array, add it\n'+
         '        //increment count\n'+
         '        if (c_flag == 0) {\n'+
         '          consonants[c_count] = inputString.charAt(index);\n'+
         '          c_count++;\n'+
         '        }\n'+
         '      }\n'+
         '      index++;\n'+
         '    }\n'+
         '    System.out.println("Vowels count : " + v_count + "( " +\n'+
         '      String.join(",", String.valueOf(vowels).trim().split("")) + " )");\n'+
         '    System.out.println("Consonants count : " + c_count + "( " +\n'+
         '      String.join(",", String.valueOf(consonants).trim().split("")) + " )");\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '22. Program to find permutations of a String.', 
         body:  
         'public class P22_FindPermutationsOfAString {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    findPermutation("", "ABC");\n'+
         '  }\n'+
         '\n'+
         '  private static void findPermutation(String perm, String word) {\n'+
         '    if (word.isEmpty()) {\n'+
         '      System.out.println(perm + word);\n'+
         '    } else {\n'+
         '      for (int i = 0; i<word.length(); i++) {\n'+
         '        //one character fix and then calculating permutations of others\n'+
         '        findPermutation(perm + word.charAt(i), word.substring(0, i) + word.substring(i + 1, word.length()));\n'+
         '      }\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '23. Program to read input from the user using the command line.', 
         body:  
         'import java.io.BufferedReader;\n'+
         'import java.io.IOException;\n'+
         'import java.io.InputStreamReader;\n'+
         'import java.util.Scanner;\n'+
         '\n'+
         'public class P23_ReadUserInput {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    ReadUserInput r = new ReadUserInput();\n'+
         '    r.scanner();\n'+
         '    r.bufferReader();\n'+
         '  }\n'+
         '\n'+
         '  public void scanner() {\n'+
         '    Scanner s = new Scanner(System.in);\n'+
         '    System.out.println("Enter username");\n'+
         '\n'+
         '    String userName = s.nextLine();\n'+
         '    System.out.println("Username is: " + userName);\n'+
         '  }\n'+
         '\n'+
         '  public void bufferReader() {\n'+
         '    try {\n'+
         '      InputStreamReader isr = new InputStreamReader(System.in);\n'+
         '      BufferedReader br = new BufferedReader(isr);\n'+
         '\n'+
         '      System.out.println("Enter Name");\n'+
         '      String name = br.readLine();\n'+
         '      System.out.println("Name: " + name);\n'+
         '    } catch (IOException e) {\n'+
         '      e.printStackTrace();\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '24. Program to perform a binary search.', 
         body:  
         'public class P24_BinarySearch {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    int[] list = { 5, 23, 45, 78, 25, 46, 12, 32, 18, 55 };\n'+
         '    int search = 250;\n'+
         '    int index = binarySearch(list, search);\n'+
         '    if (index == -1) {\n'+
         '      System.out.println("Search key not found in list");\n'+
         '    } else {\n'+
         '      System.out.println("Search key found in list at index: " + index);\n'+
         '    }\n'+
         '  }\n'+
         '\n'+
         '  public static int binarySearch(int[] input, int number) {\n'+
         '    int low = 0;\n'+
         '    int high = input.length - 1;\n'+
         '    while (high>= low) {\n'+
         '      int middle = (low + high) / 2;\n'+
         '      if (input[middle] == number) {\n'+
         '        return middle;\n'+
         '      } else if (input[middle]<number) {\n'+
         '        low = middle + 1;\n'+
         '      } else if (input[middle]>number) {\n'+
         '        high = middle - 1;\n'+
         '      }\n'+
         '    }\n'+
         '    return -1;\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '25. Program to perform sorting using a bubble sort algorithm.', 
         body:  
         'import java.util.Arrays;\n'+
         '\n'+
         'public class P25_BubbleSort {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    int[] list = { 5, 23, 45, 78, 25, 46, 12, 32, 18, 55 };\n'+
         '    bubbleSort(list);\n'+
         '  }\n'+
         '\n'+
         '  public static void bubbleSort(int[] numbers) {\n'+
         '    for (int i = 0; i<numbers.length; i++) {\n'+
         '      for (int j = numbers.length - 1; j>i; j--) {\n'+
         '        if (numbers[j]<numbers[j - 1]) {\n'+
         '          swap(numbers, j, j - 1);\n'+
         '        }\n'+
         '      }\n'+
         '    }\n'+
         '    System.out.println("Sorted Array using Bubble sort algorithm " + Arrays.toString(numbers));\n'+
         '  }\n'+
         '\n'+
         '  public static void swap(int[] array, int from, int to) {\n'+
         '    int temp = array[from];\n'+
         '    array[from] = array[to];\n'+
         '    array[to] = temp;\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '26. Program to perform sorting using a quick sort algorithm.', 
         body:  
         'import java.util.Arrays;\n'+
         '\n'+
         'public class P26_QuickSort {\n'+
         '\n'+
         '  int[] list = { 5, 23, 45, 78, 25, 46,12, 32, 18, 55 };\n'+
         '  int length = list.length;\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    QuickSort qs = new QuickSort();\n'+
         '\n'+
         '    if (qs.list == null || qs.list.length == 0) {\n'+
         '      return;\n'+
         '    }\n'+
         '    qs.quickSort(0, qs.length - 1);\n'+
         '    System.out.println("Sorted array :" + Arrays.toString(qs.list));\n'+
         '\n'+
         '  }\n'+
         '\n'+
         '  private void quickSort(int low, int high) {\n'+
         '    int i = low;\n'+
         '    int j = high;\n'+
         '    int mid = list[low + (high - low) / 2];\n'+
         '\n'+
         '    while (i<= j) {\n'+
         '      while (list[i]<mid) {\n'+
         '        i++;\n'+
         '      }\n'+
         '      while (list[j]>mid) {\n'+
         '        j--;\n'+
         '      }\n'+
         '      if (i<= j) {\n'+
         '        swap(i, j);\n'+
         '        i++;\n'+
         '        j--;\n'+
         '      }\n'+
         '      if (low<j) {\n'+
         '        quickSort(low, j);\n'+
         '      }\n'+
         '      if (i<high) {\n'+
         '        quickSort(i, high);\n'+
         '      }\n'+
         '    }\n'+
         '  }\n'+
         '\n'+
         '  private void swap(int i, int j) {\n'+
         '    int temp = list[i];\n'+
         '    list[i] = list[j];\n'+
         '    list[j] = temp;\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '27. Program to perform sorting using an insertion sort algorithm.', 
         body:  
         'import java.util.Arrays;\n'+
         '\n'+
         'public class P27_InsertionSort {\n'+
         '\n'+
         '  public static void main(String[] args) {\n'+
         '    int[] list = { 5, 23, 45, 78, 25, 46, 12, 32, 18, 55 };\n'+
         '    insertionSort(list);\n'+
         '    System.out.println("Sorted Array using Insertion sort algorithm : " + Arrays.toString(list));\n'+
         '  }\n'+
         '\n'+
         '  public static void insertionSort(int[] unsortedList) {\n'+
         '    for (int i = 1; i<unsortedList.length; i++) {\n'+
         '      int current = unsortedList[i];\n'+
         '      int j = i;\n'+
         '      while (j>0 && unsortedList[j - 1]>current) {\n'+
         '        unsortedList[j] = unsortedList[j - 1];\n'+
         '        j--;\n'+
         '      }\n'+
         '      unsortedList[j] = current;\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '29. Given an integer array, using stream API, move all zeros at the end.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '    Integer[] input = {2,0,7,1,8,0,2,0,5,3,0};\n'+
         '    List <Integer> output = Arrays.asList(input)\n'+
         '      .stream()\n'+
         '      .collect(Collectors.partitioningBy(n -> n == 0)) //partition based on our predicate\n'+
         '      .values() //values of map\n'+
         '      .stream()\n'+
         '      .flatMap(x -> x.stream())\n'+
         '      .collect(Collectors.toList());\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '30. Given a list of strings, using stream API, print a map of string & no. of duplicate characters in a string.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         'import java.util.function.Function;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '    List <String> input = Arrays.asList("cat", "rabbit", "roosteer", "hippopotamus", "pronghorn");\n'+
         '\n'+
         '    Map <String, Long> output = input.stream()\n'+
         '      .collect(Collectors.toMap(\n'+
         '        Function.identity(), //Always return its input argument\n'+
         '        a -> a.chars() //Integer form\n'+
         '        .mapToObj(c -> (char) c) //Character obj\n'+
         '        .collect(Collectors.groupingBy(s -> s, Collectors.counting())) //Gives map of character to count\n'+
         '        .values()\n'+
         '        .stream()\n'+
         '        .filter(e -> e > 1) //Filter duplicates\n'+
         '        .count()\n'+
         '      ));\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '31. Using stream API, find duplicates in an array.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '    int[] input = {1,1,2,3,4,5,6,5,7,8,8,1};\n'+
         '\n'+
         '    Set <String> output = new HashSet < > ();\n'+
         '    List <Integer> list = Arrays.stream(input).boxed().collect(Collectors.toList()); //boxed to convert int to Integer\n'+
         '\n'+
         '    list.stream()\n'+
         '      .filter(i -> Collections.frequency(list, i) > 1) //filter duplicates based on frequency\n'+
         '      .forEach(i -> output.add("Element " + i + " found " + Collections.frequency(list, i) + " times")); // Add duplicates to a set\n'+
         '\n'+
         '    for (String s: output) {\n'+
         '      System.out.println(s);\n'+
         '    }\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '32. Using stream API, create stream of random numbers.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.*;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    Random random = new Random(); //create object\n'+
         '    Stream.generate(random::nextInt) //to generate next random integer\n'+
         '      .limit(5) //limit no. of values\n'+
         '      .forEach(System.out::println);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '33. Using stream API, find the count of names by its length.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <String> names = Arrays.asList("John", "Alice", "Bob", "Jane");\n'+
         '    Map <Integer, Long> output = names.stream()\n'+
         '      .collect(Collectors.groupingBy(String::length, Collectors.counting())); //get count based on length\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '34. Using stream API, find duplicate characters in a string.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    String input = "information";\n'+
         '\n'+
         '    List <Character> output = input.chars() //Get Integer values\n'+
         '      .mapToObj(c -> (char) c) //Map to character object\n'+
         '      .collect(Collectors.groupingBy(s -> s, Collectors.counting())) //find count\n'+
         '      .entrySet() //to iterate on map\n'+
         '      .stream()\n'+
         '      .filter(e -> e.getValue() > 1) //filter based on predicate\n'+
         '      .map(Map.Entry::getKey) //fetch keys\n'+
         '      .collect(Collectors.toList());\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '35. Using stream API, remove null values from a list of string.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <String> input = Arrays.asList("apple", null, "banana", null, "orange");\n'+
         '    List <String> output = input.stream()\n'+
         '      .filter(Objects::nonNull) //filter based on our predicate\n'+
         '      .collect(Collectors.toList());\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '36. Using stream API, find longest string in list of strings.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <String> input = Arrays.asList("apple", "banana", "cherry", "date", "grapefruit");\n'+
         '    Optional <String> output = input.stream()\n'+
         '      .max(Comparator.comparingInt(String::length)); //comparing string length to find max\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '37. Using stream API, calculate average age of list of Person objects.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Person {\n'+
         '  String name;\n'+
         '  int age;\n'+
         '\n'+
         '  Person(String name, int age) {\n'+
         '    this.name = name;\n'+
         '    this.age = age;\n'+
         '  }\n'+
         '\n'+
         '  int getAge() {\n'+
         '    return this.age;\n'+
         '  }\n'+
         '}\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <Person> input = Arrays.asList(\n'+
         '      new Person("Alice", 25),\n'+
         '      new Person("Bob", 30),\n'+
         '      new Person("Charlie", 35)\n'+
         '    );\n'+
         '    double output = input.stream()\n'+
         '      .mapToInt(Person::getAge) //fetch age of person\n'+
         '      .average() //calculate average\n'+
         '      .orElse(0); //to return alternate value in case\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '38. Using stream API, merge two sorted lists into a single sorted list.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         'import java.util.stream.*;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <Integer> input1 = Arrays.asList(1, 3, 5, 7, 9);\n'+
         '    List <Integer> input2 = Arrays.asList(2, 4, 6, 8, 10);\n'+
         '\n'+
         '    List <Integer> output = Stream.concat(input1.stream(), input2.stream())\n'+
         '      .sorted()\n'+
         '      .collect(Collectors.toList());\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '39. Using stream API, find intersection of two lists.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <Integer> input1 = Arrays.asList(1, 2, 3, 4, 5);\n'+
         '    List <Integer> input2 = Arrays.asList(3, 4, 5, 6, 7);\n'+
         '\n'+
         '    List <Integer> output = input1.stream()\n'+
         '      .filter(input2::contains) //to filter common values\n'+
         '      .collect(Collectors.toList());\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '40. Using stream API, remove duplicates from a list while preserving the order.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <Integer> input = Arrays.asList(1, 2, 3, 2, 4, 1, 5, 6, 5);\n'+
         '\n'+
         '    List <Integer> output = input.stream()\n'+
         '      .distinct() // to get distinct values\n'+
         '      .collect(Collectors.toList());\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '41. Given a list of transactions, using stream API, find sum of transaction amounts for each day.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Transaction {\n'+
         '  String date;\n'+
         '  int amount;\n'+
         '\n'+
         '  Transaction(String date, int amount) {\n'+
         '    this.date = date;\n'+
         '    this.amount = amount;\n'+
         '  }\n'+
         '\n'+
         '  String getDate() {\n'+
         '    return this.date;\n'+
         '  }\n'+
         '\n'+
         '  int getAmount() {\n'+
         '    return this.amount;\n'+
         '  }\n'+
         '}\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <Transaction> input = Arrays.asList(\n'+
         '      new Transaction("2022-01-01", 100),\n'+
         '      new Transaction("2022-01-01", 200),\n'+
         '      new Transaction("2022-01-02", 300),\n'+
         '      new Transaction("2022-01-02", 400),\n'+
         '      new Transaction("2022-01-03", 500)\n'+
         '    );\n'+
         '    Map <String, Integer> output = input.stream()\n'+
         '      .collect(\n'+
         '        Collectors.groupingBy(\n'+
         '          Transaction::getDate,\n'+
         '          Collectors.summingInt(Transaction::getAmount)\n'+
         '        )\n'+
         '      );\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '42. Using stream API, find the Kth smallest element in an array.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    int k = 3;\n'+
         '    int[] input = { 4 , 2 , 7 , 1 , 5 , 3 , 6 };\n'+
         '\n'+
         '    int output = Arrays.stream(input)\n'+
         '      .sorted() //sort values\n'+
         '      .skip(k - 1) //skip k-1 values\n'+
         '      .findFirst() //pick up first value in the list\n'+
         '      .orElse(-1); //an alternate value if k is out of invalid\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '43. Using stream API, find frequency of each word.', 
         body:  
         'import java.util.function.Function;\n'+
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <String> input = Arrays.asList("apple", "banana", "apple", "cherry", "banana", "apple");\n'+
         '    Map <String, Long> output = input.stream()\n'+
         '      .collect(Collectors.groupingBy(\n'+
         '        Function.identity(),\n'+
         '        Collectors.counting()\n'+
         '      ));\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '44. Using stream API, print even and odds in an array.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <Integer> input = Arrays.asList(1, 2, 3, 4, 5, 6);\n'+
         '    Map <Boolean, List <Integer>> output = input.stream()\n'+
         '      .collect(Collectors.partitioningBy(n -> n % 2 == 0)); //partition based on our predicate\n'+
         '\n'+
         '    List < Integer > evenL = output.get(true);\n'+
         '    List < Integer > oddL = output.get(false);\n'+
         '\n'+
         '    System.out.println(evenL);\n'+
         '    System.out.println(oddL);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '45. Using stream API, find out all numbers starting with 1.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <Integer> input = Arrays.asList(10, 15, 8, 49, 25, 98, 32);\n'+
         '\n'+
         '    List <String> output = input.stream()\n'+
         '      .map(s -> s + "") // convert to string\n'+
         '      .filter(s -> s.startsWith("1")) // filter based on startsWith\n'+
         '      .collect(Collectors.toList());\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '46. Using stream API, find max value present in an array.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <Integer> input = Arrays.asList(10, 15, 8, 49, 25, 98, 32, 15);\n'+
         '\n'+
         '    int output = input.stream()\n'+
         '      .max(Integer::compare) //Compare integers to get the maximum\n'+
         '      .get();\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '47. Using stream API, find first non-repeated character in a string.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    String input = "Java articles are just awesome";\n'+
         '    Character output = input.chars()\n'+
         '      .mapToObj(c -> Character.toLowerCase(Character.valueOf((char) c)))\n'+
         '      .filter(c -> input.toLowerCase().indexOf(c) == input.toLowerCase().lastIndexOf(c))\n'+
         '      .findFirst()\n'+
         '      .orElse(null);\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '48. Using stream API, group the strings that has same characters.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    String[] input = {\n'+
         '      "abcd",\n'+
         '      "java",\n'+
         '      "dcba",\n'+
         '      "ajav",\n'+
         '      "xyz",\n'+
         '      "epam",\n'+
         '      "pame",\n'+
         '      "aepm"\n'+
         '    };\n'+
         '    Collection <List <String>> output = Arrays.asList(input)\n'+
         '      .stream()\n'+
         '      .collect(Collectors.groupingBy(s -> {\n'+
         '        char[] c = s.toCharArray(); //get the characters\n'+
         '        Arrays.sort(c); //sort array to know if it forms the same string\n'+
         '        return new String(c);\n'+
         '      }))\n'+
         '      .values(); //values of map\n'+
         '    System.out.println(output);\n'+
         '  }\n'+
         '}'
      },
      { 
         header: '49. Using stream API, find max salary employee from each department.', 
         body:  
         'import java.util.*;\n'+
         'import java.util.stream.Collectors;\n'+
         '\n'+
         'class Employee {\n'+
         '  String name;\n'+
         '  String dept;\n'+
         '  int salary;\n'+
         '\n'+
         '  Employee(String name, String dept, int salary) {\n'+
         '    this.name = name;\n'+
         '    this.dept = dept;\n'+
         '    this.salary = salary;\n'+
         '  }\n'+
         '\n'+
         '  String getDept() {\n'+
         '    return this.dept;\n'+
         '  }\n'+
         '\n'+
         '  int getSalary() {\n'+
         '    return this.salary;\n'+
         '  }\n'+
         '}\n'+
         '\n'+
         'class Main {\n'+
         '  public static void main(String[] args) {\n'+
         '\n'+
         '    List <Employee> input = Arrays.asList(\n'+
         '      new Employee("Ram", "HR", 25000),\n'+
         '      new Employee("Shiva", "IT", 50000),\n'+
         '      new Employee("Radha", "HR", 35000)\n'+
         '    );\n'+
         '    Map <String, Employee> output = input.stream()\n'+
         '      .collect(\n'+
         '        (Collectors.groupingBy(\n'+
         '          Employee::getDept,\n'+
         '          Collectors.collectingAndThen(\n'+
         '            Collectors.maxBy(\n'+
         '              Comparator.comparingInt(Employee::getSalary)\n'+
         '            ),\n'+
         '            Optional::get\n'+
         '          )\n'+
         '        )));\n'+
         '    for (String s: output.keySet()) {\n'+
         '      System.out.println(s + " -> " + output.get(s).name + " : " + output.get(s).salary);\n'+
         '    }\n'+
         '  }\n'+
         '}'
      }
    ];

   return (
      <JavaProgramsWrapper>
         <header className="entry-header">
            <h1 className="entry-title" itemProp="headline">Java Interview Programs</h1>
         </header>
         <br/>
         <AccordionPagination accordionData={data} />
         <br/>
         <CommentSection />
      </JavaProgramsWrapper>
   )
};

export default JavaPrograms;
